import axios from "axios";
import Cookies from "js-cookie";
import { ENVTokenName } from "../env";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API,
  timeout: 30000,
});
export default axiosInstance;

let api = process.env.REACT_APP_API;

axiosInstance.interceptors.request.use(
  (config: any) => {
    if (typeof window !== "undefined") {

      const url = new URL(window.location.href);
      const urlParams = new URLSearchParams(url.search ?? "");
      const isNewApiEnabled = urlParams.get("new-api") === "true";

      const isNewApiCookieSet = `${Cookies.get("new-api")}` === "true";
      const isProductionEnv = process.env.NODE_ENV === "production";
      const DEFAULT_API_GATEWAY = isProductionEnv
        ? "https://mobapi.banimode.com/api"
        : "https://apigw.banimode.com/api";

      const NEW_API_GATEWAY = isProductionEnv
        ? "https://new-mobapi.banimode.com/api"
        : "https://new-api.banimode.com/api";
      // Determine the active API Gateway
      const activeApiGateway =
        isNewApiEnabled || isNewApiCookieSet ? NEW_API_GATEWAY : DEFAULT_API_GATEWAY;

      // Update the API
      if (isNewApiEnabled || isNewApiCookieSet) api = activeApiGateway;
      config.baseURL = api;
    }
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  },

);

axiosInstance.interceptors.response.use(
  function (response) {
    if (response?.data?.data?.status_code === 401) {
      localStorage.removeItem("banimodeUserProd");
      localStorage.removeItem("banimodeUserdev");
      Cookies.remove(ENVTokenName);
      window.location.reload();
    }
    return response;
  },
  function (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("banimodeUserProd");
      localStorage.removeItem("banimodeUserdev");
      Cookies.remove(ENVTokenName);
      window.location.reload();
    }
    return Promise.reject(error);
  }
);
